<template>
    <div class="o2o-helper">
        <div v-if="hasArrow" class="info f-strong" @click="show = !show">{{text.a1}}
            <span v-show="!show" class="arr-gray-down"></span>
            <span v-show="show" class="arr-gray-up"></span>
        </div>
        <div class="help clearfix" v-show="show">
            <div class="introduce-info">
                <!--<div>{{text.a2}}</div>
                <br>-->
                <div class="f-minor">{{text.a3}}</div>
                <br>
                <div class="f-minor">{{text.a4}}</div>
            </div>
            <div class="zhj-img">
                <!--<img src="/static/img/biaoge_image.png" class="img">-->
            </div>
        </div>
    </div>
</template>
<script>
    var config = [
        {
            a1: '如何使用二维码登陆自助机？',
            a2: '如何使用二维码登陆自助机',
            a3: '第一步：请凭条形码前往大厅自助机，前往医院带GWI标识的自助设备区域。',
            a4: '第二步：请在自助机上的扫描区域扫描二维码，就可以在医院自助机登陆。'
        },
        {
            a1: '如何使用条形码打印检查报告单？',
            a2: '如何使用条形码打印检查报告单',
            a3: '第一步，请您前往医院带GWI标识自助设备区域。',
            a4: '第二步，请在自助机上的扫描区域扫描该二维码，就可以在自助机上打印检查报告。'
        },
        {
            a1: '如何使用条形码打印检验报告单？',
            a2: '如何使用条形码打印检验报告单',
            a3: '第一步，请您前往医院带GWI标识自助设备区域。',
            a4: '第二步，请在自助机上的扫描区域扫描该二维码，就可以在自助机上打印检验报告。'
        },
        {
            a1: '',
            a2: '如何使用二维码缴费',
            a3: '第一步，请您前往医院带GWI标识自助设备区域。',
            a4: '第二步，请在自助机上的扫描区域扫描该二维码，就可以在自助机上完成缴费。'
        }
    ];
    export default {
        props: {
            type: {
                type: Number
            },
            isShow: {
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            hasArrow: {
                type: Boolean,
                default: function() {
                    return true;
                }
            }
        },
        data() {
            return {
                show: this.isShow,
                text: config[this.type]
            }
        }
    }
</script>
<style lang="scss">
    .o2o-helper {
        padding: 0 1.25rem;
        .info {
            margin: 0 -1.25rem;
            text-align: center;
        }
        .help {
            margin-top: 1.25rem;
            margin-bottom: -0.75rem;
            .introduce-info {
                width: 70%;
                // margin-top: 10px;
                display: inline-block;
            }
            .zhj-img {
                width: 61.5px;
                height: 143.5px;
                float: right;
                // margin-top: 1rem;
                background-image: url(../../static/img/biaoge_image.png);
                background-size: cover;
                background-repeat: no-repeat;
            }
            .img {
                width: 100%;
                height: 100%;
            }
        }
        .bar-code-bg {
            text-align: center;
            margin: 1rem 0 0.6rem 0;
        }
    }
</style>


// WEBPACK FOOTER //
// O2OHelper.vue?3ef83e20